import Axios from '@/axios'

const sessionApi = {
  Login: '/device-manager/web/uem/user-session/login',
  VerCode: '/device-manager/web/uem/user-session/create_valid_code_photo_for_login',
  Logout: '/device-manager/web/uem/user-session/logout',
  UEMLogin: '/device-manager/web/uem/user-session/uem_login',
  UEMUserInfo: '/device-manager/web/uem/user/show'
}

/**
 * 用户登录
 * @param parameter {*}
 */
export function sessionLogin (parameter) {
  return Axios({
    url: sessionApi.Login,
    method: 'POST',
    type: 'json',
    data: parameter
  })
}

/**
 * 用户验证码
 */
export function sessionVerCode () {
  return Axios({
    url: sessionApi.VerCode,
    method: 'POST',
    type: 'json',
    data: {}
  })
}


/**
 * 用户验证码
 */
export function sessionGetUserInfo () {
  return Axios({
    url: sessionApi.UEMUserInfo,
    method: 'POST',
    type: 'json',
    data: {}
  })
}


export function sessionLogout () {
  return Axios({
    url: '/device-manager/web/uem/user-session/logout',
    method: 'post',
    type: 'json',
  })
}
